/*
 * OrderPatientSearch Messages
 *
 * This contains all the text for the OrderPatientSearch container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.OrderPatientSearch";

export default defineMessages({
  searchPatient: {
    id: `${scope}.searchPatient`,
    defaultMessage: "Search patient",
  },
});
